import {CustomMenuItem, MenuItemDivider} from "@bounce/shared/consumer/components";
import {IDashboardMenuContent} from "@bounce/shared/consumer/pages/account-dashboard";
import React from "react";
import {Colors} from "@bounce/shared/ui";
import {IconAutoPay, IconNoEntry, IconPay, IconRescheduleCalendar, IconWallet} from "@bounce/shared/consumer/bounce-ui";
import {useDashboardMenuContent} from "./useDashboardMenuContent";

const DashboardMenuContent = ({onClose, hasDivider = false}: IDashboardMenuContent) => {
  const {
    onOneTimePaymentClick,
    onReschedulePlanClick,
    onCancelMyPlanClick,
    onSwitchToAutoPayClick,
    onManagePaymentMethod,
    shouldDisplayCancelMyPlan,
    shouldDisplaySwitchToAutoPay,
    shouldDisplayDashboardMenu,
    shouldHideOneTimePayment,
    shouldDisableOneTimePayment,
    shouldDisplayReschedulePlan,
  } = useDashboardMenuContent({onClose});

  if (!shouldDisplayDashboardMenu) return null;

  return (
    <>
      {shouldDisplayReschedulePlan && (
        <CustomMenuItem
          label="Reschedule plan"
          icon={<IconRescheduleCalendar height={20} width={20} color={Colors.primary._800} />}
          onClick={onReschedulePlanClick}
        />
      )}
      {!shouldHideOneTimePayment && (
        <CustomMenuItem
          label="One time payment"
          icon={<IconPay height={20} width={20} />}
          onClick={onOneTimePaymentClick}
          disabled={shouldDisableOneTimePayment}
        />
      )}
      <CustomMenuItem
        label="Manage payment methods"
        icon={<IconWallet height={20} width={20} />}
        onClick={onManagePaymentMethod}
      />
      {shouldDisplayCancelMyPlan && (
        <CustomMenuItem
          onClick={onCancelMyPlanClick}
          label="Cancel my plan"
          icon={<IconNoEntry height={20} width={20} />}
        />
      )}
      {shouldDisplaySwitchToAutoPay && (
        <CustomMenuItem
          onClick={onSwitchToAutoPayClick}
          label="Switch to AutoPay"
          icon={<IconAutoPay height={20} width={20} />}
        />
      )}
      {hasDivider && <MenuItemDivider />}
    </>
  );
};

export default DashboardMenuContent;
